// Experiment tracker stub
export const experimentTracker = {
  quoteCalculatorShown: () => {
    // Stub: tracking when quote calculator is shown
  },
  showPrices: () => {
    // Stub: tracking when prices are shown
  },
}

export default experimentTracker
